import React, { useEffect, useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import SideBar from "../navigation/sidebar/SideBar";
import NavBar from "../navigation/topnav/NavBar";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import { IoPersonAddSharp } from "react-icons/io5";
import { HiDotsHorizontal } from "react-icons/hi";
import Loader from "../gif/loader.gif";
import axios from "axios";
import RowTitles from "../components/RowTitles";

const Scanners = () => {
  const [show, setShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (row) => {
    setSelectedRow(row);
    setShow(true);
  };
  //when loggining
  const getMembers = async () => {
    setLoading(!loading);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-scanners`
      );
      let retcode = res.data;
      setMembers(retcode);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("post error =>" + error);
    }
  };
  useEffect(() => {
    getMembers();
  }, []);
  return (
    <div className="d-flex" style={{ backgroundColor: "#f1f5f7" }}>
      <SideBar />
      {/* Main Content */}
      <div className="flex-grow-1">
        {/* Header */}
        <NavBar />
        <div className="container-fluid mt-4">
          <RowTitles title={"Dashboad"} child={"All registered members"} />
          <div className="row">
            <div className="col-md-6">
              <h4 className="mb-3">Scanners</h4>
            </div>
            <div className="col-md-6 text-end">
              <Link
                to="/register"
                className="btn  text-black me-2 mt-2 mb-3 p-2"
                style={{ borderRadius: 0, backgroundColor: "#3bc0c3" }}
              >
                <IoPersonAddSharp className="me-2" />
                Register scanner
              </Link>
            </div>
          </div>
          {loading ? (
            <img src={Loader} alt="QR Code" width={"50"} height={"50"} />
          ) : (
            <Table striped bordered hover className="shadow">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Surname</th>
                  <th>Cell</th>
                  <th>Email</th>
                  <th>Category</th>
                  <th>Gender</th>
                  <th>Reg Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {members.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <small>{row.id}</small>
                    </td>
                    <td>
                      <small>{row.name}</small>
                    </td>
                    <td>
                      <small>{row.surname}</small>
                    </td>
                    <td>
                      <small>{row.cell}</small>
                    </td>
                    <td>
                      <small>{row.email}</small>
                    </td>
                    <td>
                      <small>{row.type}</small>
                    </td>
                    <td>
                      <small>{row.gender}</small>
                    </td>
                    <td>
                      <small className="badg badge-warning">{row.date}</small>
                    </td>
                    <td>
                      <Button
                        className="bg-body text-black border-0"
                        onClick={() => handleShow(row)}
                      >
                        <HiDotsHorizontal />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Action Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRow ? (
            <div>
              <p>
                <b>ID:</b> {selectedRow.id}
              </p>
              <p>
                <strong>Purchase ID:</strong> {selectedRow.purchaseId}
              </p>
              <p>
                <strong>Title:</strong> {selectedRow.title}
              </p>
              <p>
                <strong>User:</strong> {selectedRow.user}
              </p>
              <p>
                <strong>Assigned To:</strong> {selectedRow.assignedTo}
              </p>
              <p>
                <strong>Create By:</strong> {selectedRow.createBy}
              </p>
              <p>
                <strong>Create Date:</strong> {selectedRow.createDate}
              </p>
              <p>
                <strong>Status:</strong> {selectedRow.status}
              </p>
            </div>
          ) : (
            <p>No data available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default Scanners;
